var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{staticClass:"survey__container"},[_c('stepper',{attrs:{"steps":_vm.baseSteps},on:{"completed-step":_vm.completeStep,"active-step":_vm.isStepActive,"stepper-finished":_vm.finishedSurvey}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }